import { create } from 'zustand';
import type { UserRole } from '@pe/shared';

export interface AuthUser {
  id: string;
  email: string;
  role: UserRole;
  firstName?: string | null;
  lastName?: string | null;
}

interface AuthState {
  accessToken: string | null;
  user: AuthUser | null;
  status: 'unknown' | 'authenticated' | 'guest';
  setSession: (accessToken: string, user: AuthUser) => void;
  setUser: (user: AuthUser) => void;
  clear: () => void;
  setStatus: (status: AuthState['status']) => void;
}

// Access token vit en mémoire uniquement (cf. ADR-0003).
// Le refresh token est dans un cookie HttpOnly Secure côté navigateur, jamais lu en JS.
export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  status: 'unknown',
  setSession: (accessToken, user) => set({ accessToken, user, status: 'authenticated' }),
  setUser: (user) => set({ user }),
  clear: () => set({ accessToken: null, user: null, status: 'guest' }),
  setStatus: (status) => set({ status }),
}));
